export default "__VITE_ASSET__d372c354__"